<template>
  <span hidden></span>
</template>

<script>
import GroupedShiftMealsTable from "@/components/report/shared/GroupedShiftMealsTable.vue";

/**
 * Tabela "Grupe jela" bez prikaza: ima iste podatke i redove za štampu i Excel kao stara tabela (stari tab ih čita
 * preko ref-a mealsTable), a telefon sam crta kartice po danima.
 */
export default {
  name: "GroupedMatrixData",
  extends: GroupedShiftMealsTable,
};
</script>
